import { getData_Vehicle } from '@/components/report/service';
import { crudRequest } from '@/services/api';
import { aggreArrItem, groupBys } from '@/utils/columnSearch';
import { computeWeightNotAbs } from '@/utils/query';
import { isArray } from 'lodash';
import moment from 'moment';
import { PlanWeightDetialQuery } from '../Tables/PlanDepartureTable/Sql';
import { orderBy } from 'lodash'
/**
 * Modal 详情显示类型
 */
export const ModalsType = {
  /** 网点预到达 */
  SITE: 1,
  /** 中转预到达 */
  CENTER: 2,
  /** 在库 */
  InStock: 3,
  /** 已装未发 */
  LoadNoSend: 4,
};
export default {
  namespace: 'centerWeightViewModalsTest',
  state: {
    modalsVisible: false,
    modalsType: '',
    modalsTitle: '',
    modalsNextSite: '',

    estimateTitle: '',
    estimateList: [],
    estimatePage: 1,
    actualTitle: '',
    actualList: [],
    actualPage: 1,

    ProductTypeModalsVisible: false,
    nextSite: '',
    scanSite: '',

    planProductList: [],
    acount: 0,
    preSiteToNextSiteList: [],
    planWeightDetialList: [],
  },
  effects: {
    *setReset(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          modalsVisible: false,
          estimateList: [],
          estimatePage: 1,
          actualList: [],
          actualPage: 1,
        },
      });
    },
    *queryDetail({ payload }, { call, put, select }) {
      const { scanSiteCode, nextSiteCode, modalsType } = payload;
      yield put({ type: 'update', payload: { ...payload } });
      const centerWeightViewTest = yield select(({ centerWeightViewTest }) => centerWeightViewTest);
      const { dateRange, defualtDateFormat } = centerWeightViewTest;
      const [startDate, endDate] = dateRange.map(
        date => date && moment(date).format(defualtDateFormat),
      );

      const apiPath =
        modalsType === ModalsType.SITE
          ? '/api/route/querySiteDetail'
          : '/api/route/queryCenterDetail';
      const response = yield call(crudRequest, apiPath, {
        scanSiteCode,
        nextSiteCode,
        startDate,
        endDate,
      });

      if (response.code === 1 && response.data) {

        const {
          productTypeBycalcWeights,
          siteDepartureDetailVos,
          siteDepartureDetailExportVos,
        } = response.data;
        const sortedData = orderBy(siteDepartureDetailVos, ['proportion'], ['desc']);
        const planProductList = Object.entries(productTypeBycalcWeights || {}).map(
          ([key, value]) => ({
            name: key,
            value: computeWeightNotAbs(value),
          }),
        );

        yield put({
          type: 'update',
          payload: {
            preSiteToNextSiteList: isArray(sortedData) ? sortedData : [],
            planProductList,
            planWeightDetialList: isArray(siteDepartureDetailExportVos)
              ? siteDepartureDetailExportVos
              : [],
            lineChartData: {
              ...response.data,
              siteDepartureDetailVos:sortedData
            },
          },
        });
      }
    },
  },
  reducers: {
    update(state, { payload }) {
      return { ...state, ...payload };
    },
  },
};
